import React from "react"
import {
    ContrastPillButton,
    componentStyles,
    useTheme,
} from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMap } from "@fortawesome/free-regular-svg-icons/faMap"
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars"

import ListingsMap from "~components/pages/search/listings-map"
import type { PublicSearchListingFieldsFragment } from "~graphql/generated/graphql"
import Box from "~components/shared/todo-lib-react-components/box"
import COPY from "~config/copy-constants"

export default function ListingsMapMobile({
    isMapOpen,
    setIsMapOpen,
    listings,
}: Props) {
    const styles = useStyles()

    const buttonLabel = isMapOpen ? COPY.LIST : COPY.MAP
    const icon = isMapOpen ? faBars : faMap

    return (
        <>
            <Box style={styles.mapButtonContainer}>
                <ContrastPillButton
                    isInverted={!isMapOpen}
                    onClick={() => setIsMapOpen(!isMapOpen)}
                >
                    <FontAwesomeIcon icon={icon} />
                    &nbsp;&nbsp;{buttonLabel}
                </ContrastPillButton>
            </Box>
            {isMapOpen && (
                <Box style={styles.mapContainer}>
                    <ListingsMap zoomControl={false} listings={listings} />
                </Box>
            )}
        </>
    )
}

interface Props {
    readonly isMapOpen: boolean
    readonly setIsMapOpen: (isMapOpen: boolean) => void
    readonly listings: PublicSearchListingFieldsFragment[]
}

function useStyles() {
    const theme = useTheme()

    return componentStyles({
        mapContainer: {
            position: "fixed",
            overflow: "auto",
            width: "100%",
            height: "100%",
            top: "0px",
            left: "0px",
            zIndex: theme.zIndices.overlay,
        },
        mapButtonContainer: {
            position: "fixed",
            left: "50%",
            transform: "translate(-50%)",
            bottom: "80px",
            transition: "0.4s",
            zIndex: theme.zIndices.popover,
        },
    })
}
